// Hooks
import useTranslate from "@/hooks/useTranslate/useTranslate";

// Types
import type { I_UseValidate_Return } from "../index";

/** Функция-валидатор для поля "ИНН" */
export default function innValidator(value: string): I_UseValidate_Return {
    if (!value) {
        return {
            status: false,
            message: useTranslate("tiw__validation__inn_required"),
        };
    }

    if (!/^\d{10,13}$/.test(value)) {
        return {
            status: false,
            message: useTranslate("tiw__validation__inn_range"),
        };
    }

    return {
        status: true,
        message: useTranslate("tiw__validation__success"),
    };
}
